<template>
  <div class="NoPendingError">
    <ErrorContent>
      <template v-slot:body="">
        <p>
          There are currently no active applications for
          <span class="typed-email-headline">{{ email }}</span>
        </p>
        <p>
          If you have entered your email address incorrectly, you can
          <strong>re-enter your email</strong> to try again.
        </p>
        <p>
          Alternatively, you can
          <span 
            ><strong>start a new application</strong> using this email
            address.</span
          >
        </p>
      </template>

      <template v-slot:footer>
        <b-button variant="primary" @click="reEnterEmail">
          <font-awesome-icon :icon="['fas', 'redo-alt']" /> Re-enter your email
        </b-button>

        <span><strong> OR </strong></span>

        <b-button 
          variant="outline-primary"
          @click="startNewApplication"
        >
          <font-awesome-icon :icon="['fas', 'plus-circle']" /> Start a new
          application
        </b-button>
      </template>
    </ErrorContent>
  </div>
</template>

<script>
import ErrorContent from './ErrorContent'

export default {
  name: 'NoPendingError',
  components: {
    ErrorContent
  },
  computed: {
    email() {
      return this.$store.state.auth.userId
    },
    application() {
      return this.$store.state.application
    }
  },
  methods: {
    startNewApplication() {
      this.$store.dispatch('resetError')
      this.$router.push({
        name: 'WelcomeView'
      })
    },
    reEnterEmail() {
      this.$store.dispatch('resetError')
      this.$router.push({ name: 'LoginView' })
    }
  }
}
</script>

<style lang="scss" scoped>
.typed-email-headline {
  color: $color-red;
  line-height: normal;
  font-weight: bold;
  overflow-wrap: break-word;
  word-wrap: break-word;
}

#app.v-application {
  .error__body > p {
    margin-bottom: 2rem;
  }
}
</style>
